import { ListService, TrackByService } from '@abp/ng.core';
import { Confirmation, ConfirmationService } from '@abp/ng.theme.shared';
import {  Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { filter, finalize, switchMap, tap } from 'rxjs/operators';
import { GetAssetEventsInput, AssetEventWithNavigationPropertiesDto } from '../../../../proxy/asset-events/models';
import { AssetEventService } from '../../../../proxy/asset-events/asset-event.service';
import { AssetWithNavigationPropertiesDto } from '../../../../proxy/assets/models';

@Component({
  selector: 'app-asset-events-modal',
  templateUrl: './asset-events-modal.component.html',
  styleUrls: ['./asset-events-modal.component.scss']
})
export class AssetEventsModalComponent implements OnInit {
  filters = {} as GetAssetEventsInput;

  form: FormGroup;

  isModalBusy = false;

  isModalOpen = false;

  selected?: AssetEventWithNavigationPropertiesDto;

  asset : AssetWithNavigationPropertiesDto;

  constructor(
    public readonly list: ListService,
    public readonly service: AssetEventService,
    private confirmation: ConfirmationService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {}

  buildForm() {
    const {
      description,
      assetId,
      eventTypeId,
    } = this.selected?.assetEvent || {assetId: this.asset?.asset?.id};

    this.form = this.fb.group({
      description: [description ?? null, []],
      assetId: [assetId ?? null, []],
      eventTypeId: [eventTypeId ?? null, []],
    });
  }

  hideForm() {
    this.isModalOpen = false;
    this.form.reset();
  }

  showForm() {
    this.buildForm();
    this.isModalOpen = true;
  }

  submitForm() {
    if (this.form.invalid) return;

    const request = this.selected
      ? this.service.update(this.selected.assetEvent.id, this.form.value)
      : this.service.create(this.form.value);

    this.isModalBusy = true;

    request
      .pipe(
        finalize(() => (this.isModalBusy = false)),
        tap(() => this.hideForm()),
      )
      .subscribe(this.list.get);
  }

  create(asset: AssetWithNavigationPropertiesDto) {
    this.selected = undefined;
    this.asset = asset;
    this.showForm();
  }

  update(record: AssetEventWithNavigationPropertiesDto) {
    this.selected = record;
    this.showForm();
  }

  delete(record: AssetEventWithNavigationPropertiesDto) {
    this.confirmation.warn(
      'Inventory::DeleteConfirmationMessage',
      'Inventory::AreYouSure',
      { messageLocalizationParams: [] }
    ).pipe(
      filter(status => status === Confirmation.Status.confirm),
      switchMap(() => this.service.delete(record.assetEvent.id)),
    ).subscribe(this.list.get);
  }

}
